import {UserEventsMap} from '../UserEventsMap'
import {unsafe_selectWithState} from '../../redux/utils'
import {isLicenseTrial} from '../../activeLicenseInfo/selectors'
import {USER_CLICKED_OBTAIN_LICENSE} from '../constant'
import {getLocalStorage} from '../../util/LocalStorage'
import ClassicBridge from '../../next/ClassicBridge'

export default function checkAndSendLicenseUserEvent(isFree) {
    const storage = getLocalStorage()
    const userClickedObtainLicense = storage.getItem(USER_CLICKED_OBTAIN_LICENSE, true, true)

    if (!userClickedObtainLicense && unsafe_selectWithState(isLicenseTrial)) {
        storage.setItem(USER_CLICKED_OBTAIN_LICENSE, true, true, true)
        return ClassicBridge.sendUserEvent(UserEventsMap.LICENSE_OBTAINED, {
            "Type": isFree ? "Free" : "Commercial"
        }).catch((e) => {
            //ignore event error
        })
    }
    return Promise.resolve()
}


// WEBPACK FOOTER //
// ./web/js/userEvents/checks/checkAndSendLicenceUserEvent.js